import { render, staticRenderFns } from "./ScatterChartGraph.vue?vue&type=template&id=67a221b8&scoped=true&"
import script from "./ScatterChartGraph.vue?vue&type=script&lang=js&"
export * from "./ScatterChartGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a221b8",
  null
  
)

export default component.exports